import { LOANREQUEST_STATUSES, SUB_STATUS_OFFER_AT_CUSTOMER } from 'cpool-constants';
import { z } from 'zod';

import { commonSchema } from '../common';

export const schemaOfferAtCustomer = z
    .object({
        status: z.literal(LOANREQUEST_STATUSES.OFFER_AT_CUSTOMER),
        subStatus: z.nativeEnum(SUB_STATUS_OFFER_AT_CUSTOMER).optional(),
    })
    .merge(commonSchema);
